import { Breakpoint } from "@/shared/models/breakpoint-type";
import { MutationTree } from "vuex";
import { SocialThemeWidgetState } from "../models/social-theme-widget-state";

export default <MutationTree<SocialThemeWidgetState>>{
    setCurrentBreakpoint(state, breakpoint: Breakpoint) {
        state.currentBreakpoint = breakpoint;
    },
    setMaxAmount(state, maxAmount: number)   {
        state.maxAmount = maxAmount;
    },
    setThemeItems(state, themeItems: any)   {
        state.themeItems = themeItems;
    }
}
